// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewInformationRecords-titleText-l41uT {
    font-size: 16px;
    line-height: 24px;
    margin: 0px;
}

.ViewInformationRecords-p16-zEkG1 {
    padding: 16px;
}

.ViewInformationRecords-grayBg-wQnq3 {
    background-color: var(--common-gray-bg-color);
}

.ViewInformationRecords-radiusTopLeft-yK53s {
    border-top-left-radius: 6px;
}

.ViewInformationRecords-radiusTopRight-sxRf7 {
    border-top-right-radius: 6px;
}

.ViewInformationRecords-border-Bcjew {
    border: 1px solid var(--primary-border);
}

.ViewInformationRecords-radius1-V2KQB {
    border-radius: 6px;
}

.ViewInformationRecords-borderTop-SW0Fr {
    border-top: 1px solid var(--primary-border);
}`, "",{"version":3,"sources":["webpack://./src/components/Common/TableRecords/ViewInformationRecords.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;AAC/C","sourcesContent":[".titleText {\n    font-size: 16px;\n    line-height: 24px;\n    margin: 0px;\n}\n\n.p16 {\n    padding: 16px;\n}\n\n.grayBg {\n    background-color: var(--common-gray-bg-color);\n}\n\n.radiusTopLeft {\n    border-top-left-radius: 6px;\n}\n\n.radiusTopRight {\n    border-top-right-radius: 6px;\n}\n\n.border {\n    border: 1px solid var(--primary-border);\n}\n\n.radius1 {\n    border-radius: 6px;\n}\n\n.borderTop {\n    border-top: 1px solid var(--primary-border);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleText": `ViewInformationRecords-titleText-l41uT`,
	"p16": `ViewInformationRecords-p16-zEkG1`,
	"grayBg": `ViewInformationRecords-grayBg-wQnq3`,
	"radiusTopLeft": `ViewInformationRecords-radiusTopLeft-yK53s`,
	"radiusTopRight": `ViewInformationRecords-radiusTopRight-sxRf7`,
	"border": `ViewInformationRecords-border-Bcjew`,
	"radius1": `ViewInformationRecords-radius1-V2KQB`,
	"borderTop": `ViewInformationRecords-borderTop-SW0Fr`
};
module.exports = ___CSS_LOADER_EXPORT___;
